export enum HttpStatusCode
{
	None = 0,
	OK = 200,
	Created = 201,
	Accepted = 202,
	NoContent = 204,
	Redirect = 302,
	NotModified = 304,
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
	InternalServerError = 500
}

export function isSuccessStatusCode(status: HttpStatusCode)
{
	return Math.floor(status / 200) === 1;
}

export default HttpStatusCode;